import React, { useContext } from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { EmployeeFormContext } from './EmployeeForm'
const NextOfKin = ({ formValues, setFormValues }) => {
  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title">Emergency Contacts</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="First Name"
            value={
              formValues?.employee?.personnelInfo?.emergencyContact
                ?.firstName ?? ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact: {
                      ...prev.employee?.personnelInfo?.emergencyContact,
                      firstName: e.target.value,
                    },
                  },
                },
              }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Last Name"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact?.lastName ??
              ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact: {
                      ...prev.employee?.personnelInfo?.emergencyContact,
                      lastName: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Phone Number"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact?.phone1 ??
              ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact: {
                      ...prev.employee?.personnelInfo?.emergencyContact,
                      phone1: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Relationship"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact
                ?.relationship ?? ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact: {
                      ...prev.employee?.personnelInfo?.emergencyContact,
                      relationship: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="First Name"
            value={
              formValues?.employee?.personnelInfo?.emergencyContact2
                ?.firstName ?? ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact2: {
                      ...prev.employee?.personnelInfo?.emergencyContact2,
                      firstName: e.target.value,
                    },
                  },
                },
              }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Last Name"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact2
                ?.lastName ?? ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact2: {
                      ...prev.employee?.personnelInfo?.emergencyContact2,
                      lastName: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Phone Number"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact2?.phone1 ??
              ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact2: {
                      ...prev.employee?.personnelInfo?.emergencyContact2,
                      phone1: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Relationship"
            fullWidth
            value={
              formValues?.employee?.personnelInfo?.emergencyContact2
                ?.relationship ?? ''
            }
            onChange={(e) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    emergencyContact2: {
                      ...prev.employee?.personnelInfo?.emergencyContact2,
                      relationship: e.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
export default NextOfKin
